module.exports = __webpack_public_path__ + "img/img4.5ddb2060.webp";